import { Tag } from "./Tagging.types";

export interface IStampable {
    id?: number; x: number; y: number;
    rotation: number;
}

export interface IDesk extends IStampable {
    alias: string;
    bookable: boolean;
    assignedTeams: number[];
    tags: Tag[];
}

export enum TBFontSize {
    large = "large",
    small = "small"
}

export interface ITextBox extends IStampable {
    text?: string;
    fontSize: TBFontSize;
}

export interface IRoomRectangle {
    x: number; y: number;
    width: number; height: number;
}

export type StampObj = "Desk" | "Door" | "Text";

export type ToolType = "Pointer" | "Floor" | "Room" | StampObj;

export type MouseDownOperationType = "Scroll" | "MoveDesk" | "MoveDoor" | "MoveText" | "MoveRoom" | "MoveFloor" | "RotateDesk" | "RotateDoor" | "DrawFloorplan" | "DrawRoom";

export interface IMouseDownOperation {
    type: MouseDownOperationType;
    itemIdx: number;
    initialCoords: number[];
}